const rules = {
  required: (value: string) => !!value || "Required.",
  selectionRequired: (value: Array<any>) =>
    (!!value && value.length > 0) || "Please select one.",
  email: (value: string) => {
    const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return pattern.test(value) || "Invalid e-mail.";
  },
  maxChar64: (value: string) =>
    (!!value && value.length <= 64) || !value || "Max Characters: 64",
  notOnlyBlankSpaces: (value: string) =>
    (!!value && Array.isArray(value.match(".*\\S.*"))) ||
    "Please type a name for your conversation"
};

export default rules;
